// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"aa98c29e","419":"90124688"}[chunkId] + ".chunk.js";
};